module.exports = "<div mat-dialog-content>\n    <p>{{titleData.message | translate}}</p>\n</div>\n<div mat-dialog-actions>\n    <button\n        mat-button\n        cdkFocusInitial\n        (click)=\"dialog.close(false)\"\n    >\n        {{'BTN_NO'|translate}}\n    </button>\n    <button\n        (click)=\"dialog.close(true)\"\n        mat-button\n    >\n        {{'BTN_YES'|translate}}\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-tariffs/delete-dialog/delete-dialog.component.html
// module id = ./src/app/driver-tariffs/delete-dialog/delete-dialog.component.html
// module chunks = main